import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { SxProps } from '@mui/system/styleFunctionSx';
import { Footer } from 'modules/footer';

type Props = {
  children?: React.ReactNode;
  header?: React.ReactNode;
  withFooter?: boolean;
  backgroundColor?: string;
  childrenStyles?: SxProps;
};

export const Layout = ({
  children,
  header,
  withFooter = false,
  backgroundColor = '#fafafa',
  childrenStyles
}: Props) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
    {header && header}
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        backgroundColor,
        pb: 4
      }}
    >
      <Container sx={{ pt: 5, pb: 5, ...childrenStyles }}>{children}</Container>
    </Box>
    {withFooter && <Footer />}
  </Box>
);
